const REPORT_FORM_URL = "https://forms.cancerresearchuk.org/250432902866963";

// This works with uuid or slug
export const reportFormUrl = ({ issueUrl }: { issueUrl: string }): string =>
  `${REPORT_FORM_URL}/?url=${issueUrl || ""}`;

export default reportFormUrl;
